import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@assets/images/avatar.png'


const _hoisted_1 = { class: "user-center" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = { class: "user-name flex" }
const _hoisted_4 = { class: "user-menu" }
const _hoisted_5 = { class: "lft-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "iconfont-line a-vk_zq_line1" }
const _hoisted_8 = { class: "rht-container" }
const _hoisted_9 = ["onMouseenter", "onMouseleave", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vkm_confirmModal = _resolveComponent("vkm-confirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(index == 0 ? 'active tenant-item' : 'tenant-item'),
              key: item?.id,
              onClick: ($event: any) => ($setup.swichTenanty(item.id))
            }, [
              _createElementVNode("span", null, _toDisplayString(item?.name), 1),
              _withDirectives(_createElementVNode("i", _hoisted_7, null, 512), [
                [_vShow, index == 0 ]
              ])
            ], 10, _hoisted_6))
          }), 128))
        ], 512), [
          [_vShow, _ctx.isShowTenantry && $props.tenantList.length]
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userActionList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onMouseenter: ($event: any) => ($setup.handleSwitchAction(item.value, 'in')),
              onMouseleave: ($event: any) => ($setup.handleSwitchAction(item.value, 'out')),
              onClick: ($event: any) => ($setup.handleClick(item.value)),
              class: _normalizeClass(_ctx.currentAction == item.value ? 'active menu-item' : 'menu-item'),
              key: index
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(item.label), 1)
            ], 42, _hoisted_9))
          }), 128))
        ])
      ])
    ]),
    (_ctx.isShowConfirm)
      ? (_openBlock(), _createBlock(_component_vkm_confirmModal, {
          key: 0,
          title: "确定要退出登录吗？",
          content: "退出后功能将无法使用",
          onOnCancle: $setup.handleCancle,
          onOnConfirm: $setup.handleConfirm
        }, null, 8, ["onOnCancle", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ]))
}